import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {PreferencesDialogService} from "../../services/preferences-dialogs-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class DashboardConfigurationComponent implements IController {

  preferences: any;

  constructor(private preferencesDialogService: PreferencesDialogService, private commonsAlertsService: CommonsAlertsService) {
  }

  $onInit() {
  }

  onEdit(event, property, index) {
    this.preferencesDialogService.editPreferencesProperty(event, property)
      .then((updated) => {
        const updatedValue = updated[0];
        const group = _.camelCase(updatedValue.group);

        this.preferences[group].list[index] = updatedValue;
        this.commonsAlertsService.preferencesByNameSuccess('preferences.' + property.key + '.name');
      })
      .catch((error) => {
        if (error) {
          this.commonsAlertsService.preferencesError();
        }
      })
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('dashboardConfiguration', {
    bindings: {
      preferences: '<'
    },
    template: require('./dashboard-configuration.html').default,
    controller: DashboardConfigurationComponent
  });
